export const SET_MATCHABLE = (state, payload) => (state.matchable = payload);
export const SET_NAME = (state, payload) => (state.name = payload);
